(function($) {
  $.extend($,
  {
    //NEW AUDIT DIALOG
    newAuditDialog: function(getpathname, buttonPath, helpGuid, callBackValue) {

      var dialogDiv = $("<div></div>").appendTo($(document.body));

      var titleTxt;
      var unsavedMsg;

      //returns an array of buttons
      getButtons = function() {
        var dbuttons = {};
        dbuttons[cancelBtn] = function () { closeNewAuditDialog && closeNewAuditDialog(this, dialogDiv); };
        dbuttons[selectBtn] = function() { dialogSaveClicked(false); };

        return dbuttons;
      }

      //function to display the returned data
      setdata = function(data) {
        origData = data;
        dialogDiv.html(data);
      }

      //call the controller for the data
      $.get(getpathname,
        {},
        function(data) {
          setdata(data);
        });

      //here is the actual processing
      //gets the button txts
      $.ajax({
        type: "GET",
        url: buttonPath,
        dataType: "json",
        async: false,
        success: function(data) {
          selectBtn = data.create;
          cancelBtn = data.cancel;
          titleTxt = data.title;
          unsavedMsg = data.unsavedMsg;
        }
      });

      //open the dialog
      dialogDiv.dialog({
        autoOpen: false,
        title: titleTxt,
        closeOnEscape: false,
        close: function() { $(this).dialog('destroy').remove(); },
        open: function() {},
        width: 550,
        buttons: getButtons(),
        resizable: false,
        modal: true,
        maxHeight: 400,
        position: ['centre', 150]
      });
      dialogDiv.dialog("open");
      dialogDiv.AddHelpContext(helpGuid, '{1C8F02EA-C628-44AF-A1F6-7F34AD980282}');
    },
    //SCHEDULE AUDIT DIALOG
    scheduleAuditDialog: function(getpathname, buttonPath, helpGuid, callBackValue) {

      var dialogDiv = $("<div></div>").appendTo($(document.body));

      var titleTxt;
      var unsavedMsg;

      //returns an array of buttons
      getButtons = function() {
        var dbuttons = {};
        dbuttons[closeBtn] = function() { $.genericPortalCloseDialog(this, dialogDiv, false); };
        if (selectBtn.length > 0) {
          dbuttons[selectBtn] = function() { dilaogSaveClicked(false, callBackValue); };
        }
        return dbuttons;
      };

      //function to display the returned data
      setdata = function(data) {
        origData = data;
        dialogDiv.html(data);
      };

      //call the controller for the data
      $.get(getpathname,
        {},
        function(data) {
          setdata(data);
        });

      //here is the actual processing
      //gets the button txts
      $.ajax({
        type: "GET",
        url: buttonPath,
        dataType: "json",
        async: false,
        success: function(data) {
          selectBtn = data.save;
          closeBtn = data.close;
          titleTxt = data.title;
          unsavedMsg = data.unsavedMsg;
        }
      });

      //open the dialog
      dialogDiv.dialog({
        autoOpen: false,
        title: titleTxt,
        closeOnEscape: false,
        open: function() {},
        width: 664,
        buttons: getButtons(),
        resizable: false,
        modal: true,
        maxHeight: 450,
        position: ['centre', 150]
      });
      dialogDiv.dialog("open");
      dialogDiv.AddHelpContext(helpGuid, '{E447592A-9CDF-4E9C-8BFA-547AC77749A2}');
    },
    //GENERIC CLOSE FUNCTION
    genericAuditCloseDialog: function(obj, divToGo) {
      var theObj = obj;
      var theDiv = divToGo;

      doClose = function () {
        
        try {
          $(theObj).dialog("close");

          $(theObj).dialog("destroy");

          $(theObj).remove();
        } catch(e) { }
      }

      if (getBlockMessage() != undefined && getBlockMessage().length > 0) {
        $.confirmDialog(getBlockMessage(),
          "Audit Management",
          function() {
            $.ClearNavigationWarning();
            doClose();
          });
      } else {
        doClose();
      }
    },
    //AUDIT SEARCH DIALOG
    auditSearchDialog: function(getpathname, buttonPath, helpGuid, callBackValue) {

      var searchDiv = $("<div></div>").appendTo($(document.body));

      var titleTxt;
      var unsavedMsg;

      //returns an array of buttons
      getButtons = function() {
        var dbuttons = {};
        dbuttons[closeBtn] = function() { closeSearchAuditDialog(); };
        dbuttons[selectBtn] = function() { searchAuditDilaogSaveClicked(callBackValue); };

        return dbuttons;
      };

      //function to display the returned data
      setdata = function(data) {
        origData = data;
        searchDiv.html(data);
      };

      //close the sucker down
      closeSearchAuditDialog = function() {
        $(this).dialog("close");
        $(this).dialog("destroy");
        searchDiv.remove();
      };

      //call the controller for the data
      $.get(getpathname,
        {},
        function(data) {
          setdata(data);
        });

      //here is the actual processing
      //gets the button txts
      $.ajax({
        type: "GET",
        url: buttonPath,
        dataType: "json",
        async: false,
        success: function(data) {
          selectBtn = data.save;
          closeBtn = data.close;
          titleTxt = data.title;
          unsavedMsg = data.unsavedMsg;
        }
      });

      //open the dialog
      searchDiv.dialog({
        autoOpen: false,
        title: titleTxt,
        closeOnEscape: false,
        close: function() { $(this).dialog('destroy').remove(); },
        open: function() {},
        width: 780,
        buttons: getButtons(),
        resizable: false,
        modal: true,
        maxHeight: 350,
        position: ['centre', 150]
      });
      searchDiv.dialog("open");
      searchDiv.AddHelpContext(helpGuid, '{E447592A-9CDF-4E9C-8BFA-547AC77749A2}');

    },
    //AUDIT CLOSE DIALOG
    auditCloseDialog: function(getpathname, buttonPath, helpGuid, callBackValue) {

      var closeDiv = $("<div></div>").appendTo($(document.body));

      var titleTxt;
      var unsavedMsg;
      var selectBtn;
      var closeBtn;

      //returns an array of buttons
      getButtons = function() {
        var dbuttons = {};
        dbuttons[closeBtn] = function() { $.genericPortalCloseDialog(this, closeDiv, false); };
        dbuttons[selectBtn] = function() { submitCloseAuditDialog(callBackValue); };

        return dbuttons;
      }

      //function to display the returned data
      setdata = function(data) {
        origData = data;
        closeDiv.html(data);
      };

      //call the controller for the data
      $.get(getpathname,
        {},
        function(data) {
					if (data.Successful === false) {
						$(closeDiv).dialog("close");
						return;
					}
           setdata(data);
        });

      //here is the actual processing
      //gets the button txts
      $.ajax({
        type: "GET",
        url: buttonPath,
        dataType: "json",
        async: false,
        success: function(data) {
          selectBtn = data.submit;
          closeBtn = data.cancel;
          titleTxt = data.title;
          unsavedMsg = data.unsavedMsg;
        }
      });

      //open the dialog
      closeDiv.dialog({
        autoOpen: false,
        title: titleTxt,
        closeOnEscape: false,
        open: function() {},
        width: 400,
        buttons: getButtons(),
        resizable: false,
        modal: true,
        maxHeight: 350,
        position: ['centre', 150]
      });
      closeDiv.dialog("open");
      closeDiv.AddHelpContext(helpGuid, '{E447592A-9CDF-4E9C-8BFA-547AC77749A2}');

    },
    //AUDIT GENERIC DIALOG
    auditDialog: function(getpathname, buttonPath, helpGuid, callBackValue, requiredWidth) {

      var auditDiv = $("<div id='genericAuditDialog'></div>").appendTo($(document.body));

      var titleTxt;
      var unsavedMsg;
      var selectBtn;
      var closeBtn;
      var vwidth = 675;

      if (requiredWidth != undefined && requiredWidth != null) {
        vwidth = requiredWidth;
      }

      //returns an array of buttons
      getButtons = function() {
        var dbuttons = {};
        dbuttons[closeBtn] = function() { $.genericAuditCloseDialog(this, auditDiv); };
        if (selectBtn.length > 0) {
          dbuttons[selectBtn] = function() { submitAuditDialog(callBackValue, this, auditDiv); };
        }
        return dbuttons;
      };

      //function to display the returned data
      setdata = function(data) {
        origData = data;
        auditDiv.html(data);
      };

      //call the controller for the data
      $.get(getpathname,
        {},
        function(data) {
          setdata(data);
        });

      //here is the actual processing
      //gets the button txts
      $.ajax({
        type: "GET",
        url: buttonPath,
        dataType: "json",
        async: false,
        success: function(data) {
          selectBtn = data.submit;
          closeBtn = data.cancel;
          titleTxt = data.title;
          unsavedMsg = data.unsavedMsg;
          if (data.dialogWidth != null) {
            vwidth = parseInt(data.dialogWidth);
          }
        }
      });

      //open the dialog
      auditDiv.dialog({
        autoOpen: false,
        title: titleTxt,
        closeOnEscape: false,
        close: function() {},
        open: function() {},
        width: vwidth,
        buttons: getButtons(),
        resizable: false,
        modal: true,
        maxHeight: 500
      });

      auditDiv.dialog("open");
      auditDiv.AddHelpContext(helpGuid, '{E447592A-9CDF-4E9C-8BFA-547AC77749A2}');
      return auditDiv;
    },
    //AUDIT REPORT DIALOG
    auditReportDialog: function(getpathname, buttonPath, helpGuid, callBackValue, requiredWidth) {

      var auditDiv = $("<div id='genericAuditDialog'></div>").appendTo($(document.body));

      var titleTxt;
      var unsavedMsg;
      var selectBtn;
      var closeBtn;
      var vwidth = 500;

      if (requiredWidth != undefined && requiredWidth != null) {
        vwidth = requiredWidth;
      }

      //returns an array of buttons
      getButtons = function() {
        var dbuttons = {};
        dbuttons[closeBtn] = function() { $.genericAuditCloseDialog(this, auditDiv); };
        if (selectBtn.length > 0) {
          dbuttons[selectBtn] = function() { submitAuditDialog(callBackValue, this, auditDiv); };
        }
        return dbuttons;
      };

      //function to display the returned data
      setdata = function(data) {
        origData = data;
        auditDiv.html(data);
      };

      //call the controller for the data
      $.get(getpathname,
        {},
        function(data) {
          setdata(data);
        });

      //here is the actual processing
      //gets the button txts
      $.ajax({
        type: "GET",
        url: buttonPath,
        dataType: "json",
        async: false,
        success: function(data) {
          selectBtn = data.submit;
          closeBtn = data.cancel;
          titleTxt = data.title;
          unsavedMsg = data.unsavedMsg;
          if (data.dialogWidth != null) {
            vwidth = parseInt(data.dialogWidth);
          }
        }
      });

      //open the dialog
      auditDiv.dialog({
        autoOpen: false,
        title: titleTxt,
        closeOnEscape: false,
        close: function() { $(this).dialog('destroy').remove(); },
        open: function() {},
        width: vwidth,
        buttons: getButtons(),
        resizable: false,
        modal: true,
        maxHeight: 350,
        position: ['centre', 150]
      });
      auditDiv.dialog("open");
      auditDiv.AddHelpContext(helpGuid, '{A982B482-C64A-47EE-9D9A-EDFDC6FD1297}');
      return auditDiv;
    },
    //AUDIT BASIC VIEW DIALOG
    auditBasicViewDialog: function(getpathname, buttonPath, helpGuid, auditData, callBackValue) {
      var auditDiv = $("<div id='genericAuditDialog'></div>").appendTo($(document.body));
      var titleTxt;
      var unsavedMsg;
      var selectBtn;
      var closeBtn;
      var auditId = auditData[0];
      //returns an array of buttons
      getButtons = function() {
        var dbuttons = {};
        dbuttons[closeBtn] = function() { doClose(this, auditDiv); };
        if ((auditId == "null" || auditId == "") && auditData[5] == 'True') {
          dbuttons[selectBtn] = function() { create(this, auditDiv); };
        }

        return dbuttons;
      }

      //function to display the returned data
      setdata = function(data) {
        origData = data;
        auditDiv.html(data);
      }

      //call the controller for the data
      $.get(getpathname,
        {
          auditId: auditData[0],
          startDate: auditData[1],
          EndDate: auditData[2],
          duration: 0,
          id: "",
          originalAuditId: auditData[4],
          edit: auditData[5]
        },
        function(data) {
          setdata(data);
        });

      //here is the actual processing
      //gets the button txts
      var newAud;
      if ((auditId == "null" || auditId == "") && auditData[5] == 'True') {
        newAud = true;
      }
      $.ajax({
        type: "GET",
        url: buttonPath,
        data: { autitId: newAud },
        dataType: "json",
        async: false,
        success: function(data) {
          selectBtn = data.create;
          closeBtn = data.cancel;
          titleTxt = data.title;
          unsavedMsg = data.unsavedMsg;
        }
      });

      //open the dialog
      auditDiv.dialog({
        autoOpen: false,
        title: titleTxt,
        closeOnEscape: false,
        close: function() {},
        open: function() {},
        width: 550,
        buttons: getButtons(),
        resizable: false,
        modal: true,
        maxHeight: 400,
        position: ['centre', 150]
      });
      auditDiv.dialog("open");
      auditDiv.AddHelpContext(helpGuid, '{019221F3-0EEF-40C7-A972-6FA7BEFCB514}');

    }
  })
})(jQuery);
